// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-4 {\n  background-color: #2f1700 !important;\n}\n@media (width >= 960px) {\n.theme-4 .container {\n    max-width: 900px !important;\n}\n}\n@media (width >= 1000px) {\n.theme-4 .container {\n    max-width: 1024px !important;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
